import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Switch,
} from '@heroui/react'
import { useEffect, useState } from 'react'

export default function EditBlockModal({
  isOpen = false,
  onClose,
  block = null,
  onEdit,
  isLoading = false,
}) {
  const [formData, setFormData] = useState({
    reason: '',
    is_active: true,
  })

  useEffect(() => {
    if (block) {
      setFormData({
        reason: block.reason || '',
        is_active: block.is_active,
      })
    }
  }, [block])

  const handleSubmit = () => {
    if (!block?.id) {
      console.error('No block ID available for editing')
      return
    }

    onEdit({
      reason: formData.reason || null,
      is_active: formData.is_active,
    })
  }

  const handleClose = () => {
    setFormData({
      reason: '',
      is_active: true,
    })
    onClose()
  }

  if (!block) {
    return null
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="2xl" radius="none">
      <ModalContent>
        <ModalHeader>Edit Block Rule</ModalHeader>
        <ModalBody className="space-y-4">
          <div className="p-3 bg-gray-50">
            <p className="text-sm text-gray-600">Blocked Number</p>
            <p className="font-mono text-lg">{block?.blocked_number}</p>
            <p className="text-sm text-gray-500">
              {block?.is_global ? 'Global block' : `Specific to ${block?.inbound_number}`}
            </p>
          </div>

          <Input
            label="Reason"
            placeholder="Why is this number being blocked?"
            value={formData.reason}
            onChange={e => setFormData(prev => ({ ...prev, reason: e.target.value }))}
            variant="bordered"
            radius="none"
          />

          <Switch
            isSelected={formData.is_active}
            onValueChange={value => setFormData(prev => ({ ...prev, is_active: value }))}
          >
            <div className="flex flex-col">
              <span>Active</span>
              <span className="text-sm text-gray-500">
                Whether this block rule is currently active
              </span>
            </div>
          </Switch>
        </ModalBody>
        <ModalFooter>
          <Button variant="light" onPress={handleClose} radius="none">
            Cancel
          </Button>
          <Button
            color="primary"
            onPress={handleSubmit}
            isLoading={isLoading}
            radius="none"
          >
            Update Block Rule
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
